// Date formatting utilities for consistent date display across the application

/**
 * Formats a date to MM/DD for current year, MM/DD/YYYY for other years
 * @param {Date|string|number} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDateSmart = date => {
  if (!date) return '';

  let dateObj;

  // Handle different date formats
  if (typeof date === 'string') {
    // Handle YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      dateObj = new Date(date + 'T00:00:00.000Z');
    } else {
      dateObj = new Date(date);
    }
  } else if (typeof date === 'number') {
    // Handle timestamp (seconds or milliseconds)
    dateObj = new Date(date > 1000000000000 ? date : date * 1000);
  } else if (date instanceof Date) {
    dateObj = date;
  } else {
    return '';
  }

  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    return String(date); // Return original if can't parse
  }

  const currentYear = new Date().getFullYear();
  const dateYear = dateObj.getFullYear();

  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const day = dateObj.getDate().toString().padStart(2, '0');

  if (dateYear === currentYear) {
    return `${month}/${day}`;
  } else {
    return `${month}/${day}/${dateYear}`;
  }
};

/**
 * Formats a date specifically for the Last Activity column
 * @param {Date|string|number} date - The date to format
 * @returns {string} Formatted date string with additional context
 */
export const formatLastActivity = date => {
  if (!date) return '';

  const formatted = formatDateSmart(date);
  if (!formatted) return '';

  // Add days ago calculation for recent dates
  const dateObj = new Date(date);
  const now = new Date();
  const diffTime = Math.abs(now - dateObj);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return 'Today';
  } else if (diffDays === 1) {
    return 'Yesterday';
  } else if (diffDays < 7) {
    return `${diffDays} days ago`;
  } else {
    return formatted;
  }
};
